import VMonthRangePicker from './index.vue';

export default {
  install: (Vue) => Vue.component('VMonthRangePicker', VMonthRangePicker),
};
